import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { useState, useEffect } from 'react';
import PopupTablet from '../PopUp/PopUpTablet.js';
import Overlay from '../PopUp/_Overlay.js';
import { deviceWidths } from '../../variables/widths.js';
import { FilterBarWrapper } from './style.js';
import { jsx } from 'react/jsx-runtime';

var FilterBar = function FilterBar(props) {
  var close = props.close,
    children = props.children,
    className = props.className,
    header = props.header,
    footer = props.footer,
    closed = props.closed;
  var desktopDeviceWidth = deviceWidths.desktop.replace('px', '');
  var getInitialUseOverlay = function getInitialUseOverlay() {
    return typeof window !== 'undefined' && window.innerWidth < desktopDeviceWidth;
  };
  var _useState = useState(getInitialUseOverlay),
    _useState2 = _slicedToArray(_useState, 2),
    useOverlay = _useState2[0],
    setUseOverlay = _useState2[1];
  useEffect(function () {
    setUseOverlay(window.innerWidth < desktopDeviceWidth);
    var handleResize = function handleResize() {
      setUseOverlay(window.innerWidth < desktopDeviceWidth);
    };
    window.addEventListener('resize', handleResize, false);
    return function () {
      window.removeEventListener('resize', handleResize, false);
    };
  }, [desktopDeviceWidth]);
  var isOverlayClosed = useOverlay && closed;
  var isInvalidClose = close && typeof close !== 'function';
  var isEmptyChildren = !close && !children;
  if (isOverlayClosed || isInvalidClose || isEmptyChildren) {
    return null;
  }
  return useOverlay ? /*#__PURE__*/jsx(Overlay, {
    className: "sg-filter-bar__overlay",
    onClick: close,
    children: /*#__PURE__*/jsx(FilterBarWrapper, {
      className: className,
      closed: closed,
      children: /*#__PURE__*/jsx(PopupTablet, {
        className: "sg-filter-bar__popup",
        header: header,
        close: close,
        closed: closed,
        footer: footer,
        children: children
      })
    })
  }) : /*#__PURE__*/jsx(FilterBarWrapper, {
    className: className,
    closed: closed,
    children: /*#__PURE__*/jsx(PopupTablet, {
      className: "sg-filter-bar__popup",
      header: header,
      close: close,
      closed: false,
      footer: footer,
      children: children
    })
  });
};
FilterBar.defaultProps = {
  close: null,
  children: null,
  className: null,
  header: null,
  footer: null,
  closed: false
};
var FilterBar$1 = FilterBar;

export { FilterBar$1 as default };
//# sourceMappingURL=FilterBar.js.map
